import { Spin, Tooltip } from "antd";
import PdfIcon from "@/shared/assets/svg/icons/pdf-icon.png";
import { resolveDocumentSource } from "../../../document";
import { useDocumentDownloadAction } from "../../api/use-document-download-action";
import "./document-download-button.scss";

export type DocumentDownloadButtonProps = {
  fileName: string;
  documentUrl?: string | null;
  fileId?: string | null;
  blobUrl?: string | null;
  localFile?: File | null;
  className?: string;
};

export function DocumentDownloadButton({
  fileName,
  documentUrl,
  fileId,
  blobUrl,
  localFile,
  className,
}: DocumentDownloadButtonProps) {
  const { downloadDocument, isDownloading } = useDocumentDownloadAction();

  const hasLocalFile = Boolean(localFile && localFile.size > 0);
  const source = resolveDocumentSource({ documentUrl, fileId, blobUrl });
  const isDownloadable = Boolean(source) || hasLocalFile;

  if (!isDownloadable) {
    return null;
  }

  const resolvedFileName =
    fileName || documentUrl?.split("/").pop() || "document.pdf";

  const handleDownload = () => {
    downloadDocument({
      documentUrl,
      fileId,
      blobUrl,
      fileName: resolvedFileName,
      localFile,
    }).catch(() => undefined);
  };

  return (
    <button
      type="button"
      className={["document-download-button", className].filter(Boolean).join(" ")}
      onClick={(event) => {
        event.stopPropagation();
        handleDownload();
      }}
      disabled={isDownloading}
      aria-label="Скачать документ"
    >
      {isDownloading ? (
        <Spin size="small" />
      ) : (
        <Tooltip title="Скачать документ" placement="top">
          <img
            src={PdfIcon}
            alt="Скачать документ"
            className="document-download-button__icon"
            width={16}
            height={16}
          />
        </Tooltip>
      )}
    </button>
  );
}
